import backend from "./backend";

export const getUsers = () => {
    return backend.get(`account`);
}

export const getUser = (userId) => {
    return backend.get(`account/${userId}`);
}

export const getRoles = () => {
    return backend.get(`account/role`);
}

export const getUserRoles = (userId) => {
    return backend.get(`account/${userId}/role`);
}

export const registerUser = (register) => {
    return backend.post(`account/${register}`, register)
}

export const postUser = (userDTO) => {
    return backend.post('account', userDTO)
}

export const updateUser = (userDTO) => {
    return backend.put(`account/${userDTO.userName}`, userDTO)
}

export const deleteUser = (userId) => {
    return backend.delete(`account/${userId}`);
}

export const authenticate = (credentials) => {
    return backend.post(`account/login`, credentials);
}

export const changePassword = (credentials) => {
    return backend.put(`account/changepassword`, credentials);
}

export const forgotPassword = (userName) => {
    return backend.get(`account/${userName}/forgotPassword`);
}

export const resetPasswordToken = (userName, resetPasswordToken) => {
    return backend.get(`account/${userName}/verifypasswordresettoken/${resetPasswordToken}`);
}

export const resetPassword = (resetPassword) => {
    return backend.put(`account/resetpassword`, resetPassword);
}